
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'input[appInputAlphabet]'
})
export class AlphabetOnlyDirective {
  private maxSpaces = 2;
  constructor(private el: ElementRef) { }
  
@HostListener('keydown', ['$event'])
onKeyDown(event: KeyboardEvent) {
  const regex = new RegExp(/^[a-zA-Z\s]*$/); // Allow spaces

  // Allow backspace, tab, enter, arrows, and space
  if (
    event.key === 'Backspace' || 
    event.key === 'Tab' || 
    event.key === 'Enter' || 
    event.key === 'ArrowLeft' || 
    event.key === 'ArrowRight'
  ) {
    return; 
  }
  
  // Prevent non-alphabetic characters
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
}

@HostListener('input', ['$event'])
onInput(event: InputEvent) {
  const currentValue = this.el.nativeElement.value;
  
  // Allow only alphabetic characters and a maximum of two spaces
  const alphabeticValue = currentValue.replace(/[^a-zA-Z\s]/g, ''); // Allow spaces
  const spaceCount = (alphabeticValue.match(/ /g) || []).length;

  // Limit to two spaces total
  const spaceLimitedValue = spaceCount <= 2 ? alphabeticValue : alphabeticValue.replace(/(.*?)(\s+)(.*?)/, '$1$2').trim();

  this.el.nativeElement.value = spaceLimitedValue;
}
}